var React = require('react');

function MoonInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M178.226 0C74.698 34.728 0 132.359 0 247.682 0 392.491 117.289 509.78 262.098 509.78c115.323 0 212.954-74.698 247.682-178.226-26.21 8.518-54.385 14.415-83.871 14.415-144.809 0-262.098-117.289-262.098-262.098 0-29.486 5.242-57.661 14.415-83.871z"}));
}

MoonInline.defaultProps = {"fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"1.41421","clipRule":"evenodd","viewBox":"0 0 512 512"};

module.exports = MoonInline;

MoonInline.default = MoonInline;
